import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './styles/normalize.css'
import axios from 'axios'




Vue.config.productionTip = false


// http response 拦截器
axios.interceptors.response.use(
  function(response){
    return response;
  },

  function (error){
    if(error.response){
      switch(error.response.status){
        case 401: 
        router.currentRoute.path != '/login' &
        router.replace({
          path: '/login',
          // query: {
          //   redirect: router.currentRoute.path
          // }
        })
      }
    }
    return Promise.reject(error.response.data)
  }
)

Vue.prototype.$http = axios;


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
